import { TermlyPolicyPage } from '../components/legal/TermlyPolicyPage';

const TERMLY_POLICY_ID = '1edc37ea-fcc8-4f8f-8298-7e3b5bf42580';

export function CookiePolicyPage() {
  return (
    <TermlyPolicyPage
      policyId={TERMLY_POLICY_ID}
      title="Cookie Policy"
      description="How we use cookies and similar tracking technologies."
    />
  );
}
